'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('iosdata', {
        url: '/iosdata',
        template: '<iosdata></iosdata>'
    });
}



// WEBPACK FOOTER //
// ./client/app/iosdata/iosdata.routes.js